import { Component, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { SigninPresenter } from './signin.presenter';
import { UserFacade } from '../store/user/facade/user.facade';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environments';
import { SigninService } from './signin.service';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss'],
})
export class SigninComponent implements OnInit, OnDestroy {
  authError$ = this.userFacade.authError$;
  stripeExpire$ = this.userFacade.stripeExpire$;
  authForm!: FormGroup;
  isEmailEntered: boolean = false;
  isPasswordEntered: boolean = false;
  isSignUpFlow: boolean = false;
  submitted: boolean = false;
  isLoading = false;
  title: string = 'Sign in';
  subTitle: string =
    'To sign in, please enter an email and password or create an account to get started.';
  bodyText = 'This text can be updated in modal 1';
  private url: string;
  isPackageExpired: boolean = false;
  errorMsg: string = '';
  subMessage: string =
    'To sign in, please enter an email and password or create an account to get started.';
  CognitoGroupNotAssigned = false;
  constructor(
    private router: Router,
    private signinPresenter: SigninPresenter,
    private userFacade: UserFacade,
    private toastr: ToastrService,
    private signinService: SigninService,

  ) { }

  ngOnInit() {
    this.url = environment.baseUrl;
    if (history.state.navigationId === 1) {
      // First navigation
      history.pushState(null, '', location.href);
      window.addEventListener('popstate', () => {
        history.pushState(null, '', location.href);
      });
    }
    this.authForm = this.signinPresenter.initializeAuthForm();

    this.userFacade.authError$.subscribe(error => {
      // this.isPackageExpired = false;
      this.isLoading = false;
      console.log('this.isLoading:', error);

    });


  }

  onSave() {
    console.log('Save changes clicked');
    // Handle save action here
  }

  get f(): { [key: string]: AbstractControl } {
    return this.authForm.controls;
  }

  clearInput(input: string): void {
    console.log("ws");
    this.authForm.controls['email'].setValue('');
  }

  login() {
    this.isPackageExpired = false;
    if (this.isLoading) return;
    this.errorMsg = '';
    this.submitted = true;
    // this.isPackageExpired = false;
    if (this.authForm.invalid) {

      return;

    }
    this.isLoading = true;
    // this.userFacade.authorize(this.authForm.value);
    this.signinService.authorizeUser(this.authForm.value).subscribe(({ status, message }) => {
      console.log('Response from authorizeUser:', status, message);
      switch (status) {
        case 200:
          this.isPackageExpired = false;
          console.log('Success:', message);
          this.signinService.getUserDetailsAndRedirect().subscribe(({ status, message }) => {
            this.isLoading = false;
          }
          );
          break;
        case 409:
          this.isLoading = false;
          this.isPackageExpired = false;
          this.errorMsg = message;
          console.log('Password reset required:', message);
          break;
        case 402:
          this.isPackageExpired = true;
          this.isLoading = false;
          this.subMessage = message;
          if (message == 'Your plan has expired. Please update to continue the access.') {
            this.CognitoGroupNotAssigned = false;
          } else {
            this.CognitoGroupNotAssigned = true;
          }
          console.log('Subscription expired:', message);
          break;
        default:
          this.errorMsg = message;
          this.isPackageExpired = false;
          this.isLoading = false;
          break;
      }
    });
  }

  hasEmailError(): boolean {
    return this.authForm.controls['email'].invalid;
  }

  navigateToCreateAccount() {
    this.isLoading = false;
    this.isPackageExpired = false;
    this.errorMsg = '';
    this.router.navigate(['/landing-page'], {
      queryParams: {
        isPricing: true
      }
    });
  }

  startNewSubscription() {
    this.isLoading = false;
    this.isPackageExpired = false;
    this.errorMsg = '';
    this.router.navigate(['/landing-page'], {
      queryParams: {
        isPricing: true
      }
    });
  }

  navigateToPasswordHelp() {
    this.isLoading = false;
    this.isPackageExpired = false;
    this.router.navigate(['/password-help']);
  }

  onPrivacy() {
    console.log(this.url + "privacy-notice")
    window.open("privacy-policy", '_blank');
  }

  openInNewWindow(route: string) {
    const url = this.router.serializeUrl(
      this.router.createUrlTree([route])
    );

    window.open(url, '_blank');
  }

  navigateToCreateVILSAccount() {
    this.isLoading = false;
    this.router.navigate(['/learning']);
  }

  openStripePortal() {
    const portalLink = environment.stripe.portalLink;
    window.open(portalLink, '_blank');
  }

  ngOnDestroy(): void {
    //this.isLoading = false;p
    this.userFacade.resetErrorMsg();
  }

}
